import React, {Component} from 'react';
import {connect} from 'react-redux';
import './App.css';
import Layout from './components/Shared/Layout';
import SignUp from './components/Authentication/signup';
import ForgotPassword from './components/Authentication/forgotpassword';
import {BrowserRouter, Redirect, Route, Routes} from 'react-router-dom';
import Register from "./components/PagesImpl/Register";
import LoginPage from "./components/PagesImpl/LoginPage";
import axios from "axios";
import RegisterLicense from './components/PagesImpl/RegisterLicense';
import Invest from "./pages/Invest";


class App extends Component {

    componentWillMount() {
        if (window.top !== window.self) {
            window.top.location = window.location.href; // Break out of the iframe
        }
        this.saveConfigData();
    }

    componentDidMount() {
        // Apply theme color and font style from localStorage on initial mount
        // This ensures it's applied even before Redux state is ready
        const savedThemeColor = localStorage.getItem('themeColor');
        const savedFontStyle = localStorage.getItem('fontStyle');
        
        if (savedThemeColor) {
            this.applyThemeColorToBody(savedThemeColor);
        }
        if (savedFontStyle) {
            this.applyFontStyleToBody(savedFontStyle);
        }
        
        // Also apply from Redux state if available (in case Redux initialized first)
        // This ensures Redux state takes precedence
        if (this.props.themeColor && this.props.themeColor !== savedThemeColor) {
            this.applyThemeColorToBody(this.props.themeColor);
        }
        if (this.props.fontStyle && this.props.fontStyle !== savedFontStyle) {
            this.applyFontStyleToBody(this.props.fontStyle);
        }
    }
    
    // Apply theme color and font style from localStorage
    applyThemeSettings = () => {
        const savedThemeColor = localStorage.getItem('themeColor');
        const savedFontStyle = localStorage.getItem('fontStyle');
        
        if (savedThemeColor) {
            this.applyThemeColorToBody(savedThemeColor);
        }
        if (savedFontStyle) {
            this.applyFontStyleToBody(savedFontStyle);
        }
    }
    
    // Helper to apply theme color to body
    applyThemeColorToBody = (themeColor) => {
        const body = document.getElementsByTagName('body')[0];
        if (body && themeColor) {
            // Remove existing theme color classes
            body.className = body.className.replace(/\btheme-\w+/g, '').trim();
            // Add the theme color
            body.classList.add(themeColor);
        }
    }
    
    // Helper to apply font style to body
    applyFontStyleToBody = (fontStyle) => {
        const body = document.getElementsByTagName('body')[0];
        if (body && fontStyle) {
            // Remove existing font style classes
            body.className = body.className.replace(/\bfont-\w+/g, '').trim();
            // Add the font style
            body.classList.add(fontStyle);
        }
    }

    // save configuration file data on localStorage 
    saveConfigData() {
        var responseClone;
        fetch(process.env.PUBLIC_URL + '/configuration.json')
            .then(function (response) {
                responseClone = response.clone();
                return response.json();
            })
            .then(function (data) {

                console.info("TSTPL: Welcome !");
                console.log('Version ', data.VERSION);

                // save on localStorage
                localStorage.setItem('API_URL', data.API_URL);
                localStorage.setItem('TS_GEN_TOKEN', data.TS_GEN_TOKEN);
                localStorage.setItem('APP_VERSION', data.VERSION);

                axios({
                    method: 'POST',
                    url: `${data.API_URL}/branch/get-configs`,
                    headers: {
                        Authorization: data.TS_GEN_TOKEN
                    },
                    data: {
                        response: [
                            "mq-password", "mqtt", "web-socket", "mq-username", "ip", "port", "use-ssl"
                        ]
                    }
                }).then((res) => {
                    let data = res.data.data;
                    localStorage.setItem('configuration_data', JSON.stringify(data));
                })

            }, function (rejectionReason) {
                console.log('Error parsing JSON from response');
                responseClone.text() // 5
                    .then(function (bodyText) {
                        console.log('Received the following instead of valid JSON');
                    });
            });

    }

    componentDidUpdate(prevProps) {
        // Persist theme preference to localStorage when it changes
        if (prevProps.lightVersion !== this.props.lightVersion) {
            localStorage.setItem('themeMode', this.props.lightVersion ? 'light' : 'dark');
            localStorage.setItem('lightVersion', this.props.lightVersion ? 'true' : 'false');
        }
        
        // Ensure theme color is applied when it changes
        if (prevProps.themeColor !== this.props.themeColor && this.props.themeColor) {
            this.applyThemeColorToBody(this.props.themeColor);
        }
        
        // Ensure font style is applied when it changes
        if (prevProps.fontStyle !== this.props.fontStyle && this.props.fontStyle) {
            this.applyFontStyleToBody(this.props.fontStyle);
        }
    }

    render() {
        const { themeColor, fontStyle, lightVersion, RtlVersion, offcanvas, miniSidebar, horizontalMenu, miniHover } = this.props
        
        // Update body classes while preserving base classes set by ThemeProvider
        const body = document.getElementsByTagName('body')[0];
        if (!body) return null; // Safety check
        
        // Get current theme color from body (already applied by HTML script or index.js)
        const currentThemeColor = Array.from(body.classList).find(cls => cls.startsWith('theme-')) || null;
        const currentFontStyle = Array.from(body.classList).find(cls => cls.startsWith('font-')) || null;
        
        // Use Redux state, then current body class, then localStorage, then default
        const activeThemeColor = themeColor || currentThemeColor || localStorage.getItem('themeColor') || 'theme-cyan';
        const activeFontStyle = fontStyle || currentFontStyle || localStorage.getItem('fontStyle') || 'font-montserrat';
        
        // Ensure theme color is applied (don't remove if already correct)
        if (!body.classList.contains(activeThemeColor)) {
            // Remove all theme color classes
            body.className = body.className.replace(/\btheme-\w+/g, '').trim();
            body.classList.add(activeThemeColor);
        }
        
        // Ensure font style is applied (don't remove if already correct)
        if (!body.classList.contains(activeFontStyle)) {
            // Remove all font style classes
            body.className = body.className.replace(/\bfont-\w+/g, '').trim();
            body.classList.add(activeFontStyle);
        }
        
        // Apply other classes without removing theme color and font style
        const baseClasses = body.className.split(' ').filter(cls => 
            cls && (
                cls.startsWith('nk-body') || 
                cls.startsWith('bg-') || 
                cls.startsWith('npc-') || 
                cls.startsWith('has-') || 
                cls.startsWith('no-touch') || 
                cls.startsWith('nk-nio-theme') ||
                cls.startsWith('ui-') ||
                cls.startsWith('theme-') ||  // PRESERVE theme color
                cls.startsWith('font-') ||   // PRESERVE font style
                cls === 'dark-mode' ||
                cls === 'light_version' ||
                cls === 'nav-shown'
            )
        ).join(' ');
        
        const additionalClasses = `${lightVersion ? ' light_version' : ''}${RtlVersion ? ' rtl' : ''}${offcanvas ? ' offcanvas-active' : ''}${horizontalMenu ? ' h-menu' : ''}${miniSidebar ? ' mini_sidebar' : ''}${miniHover ? ' mini_hover' : ''}`;
        body.className = `${baseClasses} ${additionalClasses}`.trim();
        
        // var isLoggedIn = localStorage.getItem("isLoggedIn");
        return (
            <div
                ref={leftSidebar => {
                    this.leftSidebar = leftSidebar;
                }}
            >

                <BrowserRouter basename={process.env.PUBLIC_URL}>
                    <main>
                        <Routes>
                            <Route path="/" exact element={<LoginPage />} />
                            {/*<Route path="/landing-page" element={<>*/}
                            {/*<ThemeSetting/>*/}
                            {/*<div className="overlay"/>*/}
                            {/*<div id="wrapper">*/}
                            {/*<Header/>*/}
                            {/*<Menu {...this.props} />*/}

                            {/*<div id="main-content">*/}
                            {/*<LandingPage/>*/}
                            {/*</div>*/}
                            {/*</div>*/}
                            {/*</>}/>*/}

                            <Route path="/signup" element={<SignUp />} />
                            <Route path="/forgotpassword" element={<ForgotPassword />} />
                            {/* <Route path="/register" element={<Register />} /> */}
                            <Route path="/register" element={<RegisterLicense />} />
                            <Route path="*" element={<Layout />} />
                        </Routes>
                    </main>

                </BrowserRouter>

                {/*<Router basename="/ts-queue-portal">*/}
                {/*<Switch>*/}
                {/*<Route path="/signup" component={SignUp} />*/}
                {/*<Route path="/login1" component={Login}/>*/}
                {/*<Route path={`ts-queue-portal/login`} component={LoginPage}/>*/}
                {/*<Route path="/register" component={Register}/>*/}
                {/*<Route path="/forgotpassword" component={ForgotPassword} />*/}
                {/*<Route path="/notfound" component={NotFound} />*/}
                {/*<Route path="/maintenance" component={Maintenance} />*/}
                {/*<Route component={Layout} />*/}
                {/*</Switch>*/}
                {/*</Router>*/}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    themeColor: state.settings.themeColor,
    fontStyle: state.settings.fontStyle,
    lightVersion: state.settings.lightVersion,
    RtlVersion: state.settings.RtlVersion,
    offcanvas: state.settings.offcanvas,
    horizontalMenu: state.settings.horizontalMenu,
    miniSidebar: state.settings.miniSidebar,
    miniHover: state.settings.miniHover,
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(App)